import React, { useState, useEffect } from 'react';
import firebase from "firebase";
const database = firebase.firestore();

function Resume() {

    const [educations, setEducations] = useState([]);
    const [skills, setSkills] = useState([]);
    const [works, setWorks] = useState([]);

    useEffect(()=>{

        database.collection("educations").orderBy("order","asc").get().then(querySnapshot => {
            setEducations(querySnapshot.docs.map(doc => doc.data()));
        })
        database.collection("skills").orderBy("nivel","desc").get().then(querySnapshot => {
            setSkills( querySnapshot.docs.map((doc) => {
                return doc.data();

            }));
        })
        database.collection("works").orderBy("dataInicio","desc").get().then(querySnapshot => {
            setWorks( querySnapshot.docs.map((doc) => {
                 return doc.data();
            }));
        })

    },[])

    const educationsShow = () => {
        return educations.map(function(education){
                return <div key={education.instituicao + education.curso}><h3>{education.instituicao}</h3>
                <p className="info">{education.curso} <span>&bull;</span><em className="date">{education.dataFinal?education.dataFinal.toDate().toLocaleDateString():""}</em></p>
                <p>{education.status}</p></div>
        })
    }

    const skillsChildShow = (skillsParent) => {
        console.log(skillsParent)
        if(skillsParent.skills){

            return skillsParent.skills.map(function(skillChild) {
                var className = 'bar-expand ' + skillChild.nome.toLowerCase();
                return <li key={skillChild.nome}>
                    <span style={{width: skillChild.nivel + "%", color: "white", textAlign: "center"}} className={className}>
                        { skillChild.nivel + "%"}
                    </span><em>{skillChild.nome}</em>
                    {skillsChildShow(skills)}
                </li>
            })
        }
    }

    const skillsShow = () => {
        if(skills) {
            return skills.map(function (skills) {
                var className = 'bar-expand ' + skills.nome.toLowerCase();
                return <div> <li key={skills.nome}>
                    <span style={{width: skills.nivel + "%", color: "white", textAlign: "center"}} className={className}>
                        { skills.nivel + "%"}
                    </span><em>{skills.nome}</em>

                </li>
                <ul>
                    {skillsChildShow(skills)}
                </ul></div>
            })
        }
    }

    const worksShow = () => {
        if(works) {
            return works.map(function (work) {
                var className = 'bar-expand ' + work.local.toLowerCase();
                return <div key={work.local}><h3>{work.local} - {work.cidadeEstado}</h3>
                             <p className="info">{work.cargo}<span>&bull;</span>
                                 <em className="date">
                                     {work.dataInicio?work.dataInicio.toDate().toLocaleDateString():"-"} a {work.dataFim?work.dataFim.toDate().toLocaleDateString():"Hoje"}
                                 </em></p>
                             <p>{work.descricao}</p>
                         </div>
            })
        }
    }

    // if(this.props.data){
    //   var skillmessage = this.props.data.skillmessage;
    //   var education = this.props.data.education.map(function(education){
    //     return <div key={education.school}><h3>{education.school}</h3>
    //     <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
    //     <p>{education.description}</p></div>
    //   })
    //   var work = this.props.data.work.map(function(work){
    //     return <div key={work.company}><h3>{work.company}</h3>
    //         <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
    //         <p>{work.description}</p>
    //     </div>
    //   })
    //   var skills = this.props.data.skills.map(function(skills){
    //     var className = 'bar-expand '+skills.name.toLowerCase();
    //     return <li key={skills.name}><span style={{width:skills.level}}className={className}></span><em>{skills.name}</em></li>
    //   })
    // }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {educationsShow()}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {worksShow()}
        </div>
    </div>



      <div className="row skill">

         <div className="three columns header-col">
            <h1><span>Skills</span></h1>
         </div>

         <div className="nine columns main-col">

				<div className="bars">
				   <ul className="skills">
					  {skillsShow()}
					</ul>
				</div>
			</div>
      </div>
   </section>
    );

}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/Resume.js